import { SVGProps } from 'react'

const ClockIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='10' height='11' viewBox='0 0 10 11' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g clipPath='url(#clip0_354_191664)'>
                <path
                    d='M5.00065 9.66927C7.30184 9.66927 9.16732 7.80379 9.16732 5.5026C9.16732 3.20142 7.30184 1.33594 5.00065 1.33594C2.69946 1.33594 0.833984 3.20142 0.833984 5.5026C0.833984 7.80379 2.69946 9.66927 5.00065 9.66927Z'
                    stroke='#939496'
                    strokeWidth='1.00729'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5 3.00293V5.50293L6.66667 6.33626'
                    stroke='#939496'
                    strokeWidth='1.00729'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_354_191664'>
                    <rect width='10' height='10' fill='white' transform='translate(0 0.50293)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ClockIcon
